import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'
import asyncWrapper from '../../../../shared/javascripts/hocs/asyncWrapper'
import PageTitle from '../../../../shared/javascripts/components/PageTitle/PageTitle'
import Loading from '../../../../shared/javascripts/components/Loading'
import Breadcrumbs from '../../../../shared/javascripts/components/Breadcrumbs'
import List from './List'
import Select from 'react-select-plus'

import UserApi from '../../api/UserApi'

class Users extends Component {
  constructor(props) {
    super(props)

    this.state = {
      users: [],
      teams: [],
      selectedTeamId: 0,
      loadingTeam: false
    }
  }

  componentDidMount() {
    UserApi.fetchUsers()
      .then(this.props.handleErrors)
      .then(response => {
        this.setState({users: response.users, teams: response.teams, selectedTeamId: response.team_id},
          ()=>this.props.setLoading()
        )
      }).catch(error => console.log(error))
  }

  componentDidUpdate(prevProps, prevState) {
    if(prevState.selectedTeamId !== this.state.selectedTeamId) {
      this.setState({loadingTeam: true}, () => {
        UserApi.fetchTeam(this.state.selectedTeamId)
          .then(this.props.handleErrors)
          .then(response => {
            this.setState({users: response, loadingTeam: false})
          }).catch(error => console.log(error))
      })
    }
  }

  handleTeamChange(selectedTeam) {
    this.setState({ selectedTeamId: selectedTeam.id });
  }

  render() {
    if(this.props.loading) {return <Loading />}
    if(this.props.error) {return <h1 className='text-danger'>Error</h1>}

    const { match } = this.props;
    let breadcrumbPaths = [
      {name: 'Dashboard', path: '/'},
    ]

    return (
      <div className='Users'>
        <PageTitle title='Users' rightNav={<Breadcrumbs paths={breadcrumbPaths} />} />
        <hr />
        <div className="row">
          <div className="col-md-4">
            <Select
              name="form-field-name"
              valueKey='id'
              labelKey='name'
              clearable={false}
              isLoading={this.state.loadingTeam}
              value={this.state.selectedTeamId}
              onChange={this.handleTeamChange.bind(this)}
              options={this.state.teams}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-md-12">
            <List users={this.state.users} match={match} />
          </div>
        </div>
      </div>
    );
  }
}


export default asyncWrapper(withRouter(Users))


// WEBPACK FOOTER //
// ./src/manager/javascripts/components/Users/Users.jsx